import BaseAdapter from "@/plugins/BaseAdapter";

// TODO
export default class TableAdapter extends BaseAdapter{
  constructor (fields, showFullName = false){
    super()
    this.fields = fields
    this.showFullName = showFullName
    this.headers = []
    this.records = []
    this.setUpHeaders()
  }

  addAdditionalHeaders(){

  }
}
